import React, { useEffect } from 'react';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { Row, Col, Container, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import renderField from '../../../shared/components/custom/Field';
import validateGoalSponsorGameForm from './validateGoalSponsorGameForm';
import { partial } from '../../../util/translation/translation';
import TimetableIcon from 'mdi-react/TimetableIcon';
import moment from 'moment';

const SCORE_COUNT_LABELS = {
  goal: 'goalCount',
  point: 'pointCount',
  attendant: 'attendantCount',
  holeInOne: 'holeInOneCount',
  medal: 'medalCount',
};

const GoalSponsorGameForm = ({
  game,
  handleSubmit,
  initialize,
  type,
  planId,
  formValues,
  planScoreType,
}) => {
  const s = partial('shared');
  const p = partial('goalSponsor');
  const selectedScoreType = planScoreType || 'goal';
  const countLabelKey =
    SCORE_COUNT_LABELS[selectedScoreType] || SCORE_COUNT_LABELS.goal;
  const countLabel = p(countLabelKey);
  useEffect(() => {
    if (game) {
      initialize({
        title: game.title,
        startDate: moment(game.startDate).format('YYYY-MM-DDTHH:mm'),
        goalCount: game.goalCount,
      });
    } else {
      initialize({});
    }
  }, [game]);
  return (
    <form className="form" onSubmit={handleSubmit}>
      <div
        style={{
          backgroundColor: '#F4F4F6',
          borderRadius: 4,
          borderColor: '#D7DAE0',
          borderStyle: 'solid',
          borderWidth: 1,
          marginTop: 10,
          marginBottom: 10,
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderBottomWidth: 1,
            borderBottomStyle: 'dashed',
            borderColor: '#D7DAE0',
            padding: '10px 10px 10px 10px',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                fontSize: 16,
                lineHeight: '24px',
                color: 'black',
                fontWeight: 'bold',
              }}
            >
              {s('details')}
            </div>
          </div>
        </div>
        <div style={{ padding: '10px' }}>
          <Container>
            <Row>
              <Col md={6}>
                <div className="form__form-group">
                  <span className="form-header">{s('title')}*</span>
                  <Field
                    name="title"
                    component={renderField}
                    placeholder={s('title')}
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="form__form-group">
                  <span className="form">{s('startDate')}*</span>
                  <div className="form__form-group-field">
                    <div className="form__form-group-icon">
                      <TimetableIcon />
                    </div>
                    <Field
                      name="startDate"
                      component={renderField}
                      type="datetime-local"
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <div className="form__form-group">
                  <span className="form-header">{countLabel}*</span>
                  <div className="form__form-group-field">
                    <Field
                      name="goalCount"
                      component={renderField}
                      type="number"
                      placeholder={countLabel}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <Col>
        <Button color="primary">
          {type === 'create' ? `${s('create')}` : `${s('save')}`}
        </Button>
        <Link to={`/goal-sponsor/subscription-plans/edit/${planId}?tab=2`}>
          <Button>{s('close')}</Button>
        </Link>
      </Col>
    </form>
  );
};

const reduxF = reduxForm({
  form: 'goal_sponsor_game_form',
  validate: validateGoalSponsorGameForm,
});

const mapStateToProps = (state) => ({
  formValues: getFormValues('goal_sponsor_game_form')(state),
});

export default connect(mapStateToProps)(reduxF(GoalSponsorGameForm));
